/**
 * Client-side tenant-name validation (PTV2-1021). This mirrors the server's
 * contract regex `^[a-z][a-z0-9_]{0,30}$` and reserved-word set exactly; it is
 * a UX nicety only — the server re-validates and is authoritative (deny by
 * default). Keep this in lock-step with `CreateTenantRequest` validation in
 * core.
 */

export const TENANT_NAME_PATTERN = /^[a-z][a-z0-9_]{0,30}$/;

/** Names that core only allows via cluster-init; the UI rejects them outright. */
export const RESERVED_TENANT_NAMES: ReadonlySet<string> = new Set(['default', 'base']);

export type TenantNameError = 'required' | 'format' | 'reserved';

/** Returns the first validation problem with `name`, or `null` when valid. */
export function validateTenantName(name: string): TenantNameError | null {
  const trimmed = name.trim();
  if (trimmed.length === 0) return 'required';
  if (!TENANT_NAME_PATTERN.test(trimmed)) return 'format';
  if (RESERVED_TENANT_NAMES.has(trimmed)) return 'reserved';
  return null;
}
